export const REMOTE_CONFIG_KEY_IS_NOTIFICATION_TASK_ENABLED =
  "task_open_notification_display";
export const REMOTE_CONFIG_KEY_MEMBER_LIFETIME_AND_WEEKLY_PRODUCT =
  "member_lifetime_and_weekly_product";
/** App 最低 buildNumber；JSON `{ "ios": number, "android": number }` */
export const REMOTE_CONFIG_KEY_APP_MINIMUM_BUILD_NUMBER =
  "app_minimum_build_number";
/** 是否允许关闭 App 升级引导弹窗；false 时隐藏 Maybe Later 且 Update now 不关闭弹窗 */
export const REMOTE_CONFIG_KEY_CAN_CLOSE_UPGRADE_MODAL =
  "can_close_upgrade_modal";
/**
 * App 更新弹窗文案覆盖。JSON，每种语言两个槽：
 * `{"en":"", "zh-TW":"", "en-default":{"title":…,"body":…}, "zh-TW-default":{…}}`
 * 取值链 **覆盖槽 → `-default` 槽 → 组件内置文案**，逐字段独立。
 * 缺当前语言时**不跨语言回退**（回退会让繁中用户看到英文）。
 * 语义与原生 `kmp-app/.../update/AppUpdateReleaseNotes.kt` 必须一致 —— 同一条 RC 被两端读。
 */
export const REMOTE_CONFIG_KEY_APP_UPDATE_RELEASE_NOTES =
  "app_update_release_notes";
/** Plaid 门控模式：`free_trial`（默认）| `paywall_first` */
export const REMOTE_CONFIG_KEY_PLAID_GATE_MODE = "plaid_gate_mode";
/** Plaid 免费试链天数（文案展示；权威天数在后端 Nacos） */
export const REMOTE_CONFIG_KEY_PLAID_FREE_TRIAL_DAYS = "plaid_free_trial_days";
/**
 * iOS App 内订阅管理外跳项（换卡）开关，EDG-552 fe-spec §3.7 / R12。默认（未配置 / 读取失败）视为开启。
 * **只用于关闭**：被 App Store 审核或合规质疑时置 `false` 即时隐藏，无需发版。
 * ⚠️ 禁止「审核期关、过审后开」—— 那是 App Store 2.3.1 明确禁止的隐藏功能。
 */
export const REMOTE_CONFIG_KEY_IOS_APP_EXTERNAL_MANAGE_ENABLED =
  "ios_app_external_manage_enabled";
